import type { SelectProps } from '@mantine/core'
import { Select } from '@mantine/core'
import React from 'react'

import { useTranslation } from '@flecto/translations'
import { EDocType } from '@flecto/types'

type SelectDocType = EDocType | string | number
interface SelectDocTypeProps
  extends Omit<SelectProps, 'data' | 'value' | 'defaultValue'> {
  value?: SelectDocType
  defaultValue?: SelectDocType
}

export const SelectDocType = (props: SelectDocTypeProps) => {
  const { t: translate } = useTranslation('saas', { keyPrefix: 'customers' })
  const availableDocuments = [
    {
      value: EDocType.CIVIL,
      label: translate('document_type.civil'),
    },
    {
      value: EDocType.PASSPORT,
      label: translate('document_type.passport'),
    },
    {
      value: EDocType.DRIVERS_LICENSE,
      label: translate('document_type.drivers_license'),
    },
    {
      value: EDocType.OTHER,
      label: translate('document_type.other'),
    },
  ]

  return (
    <Select
      {...props}
      data={availableDocuments}
      data-testid='select-locale'
      value={props.value ? String(props.value) : undefined}
      defaultValue={props.defaultValue ? String(props.defaultValue) : undefined}
    />
  )
}
